<style scoped>
.el-aside {
    display: flex;
    justify-content: center;
    align-items: center;
}

section{
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.logo {
  width: 200px;
}

.headerLogo,.logo{
  cursor: pointer;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.district-tag {
  font-size: 14px;
  color: #606266;
}
.header-link {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<template>
  <el-container>
    <el-aside width="auto" class="header-logo tap" >
      <img class="logo" src="@/assets/imgs/logo.png" alt="Logo" />
    </el-aside>
    <div class="header-link">
      <el-button type="primary" size="small" icon="el-icon-monitor" @click="goToScreen">数据大屏</el-button>
    </div>
    <el-aside width="auto" class="header-logo tap" >
      <div class="user-info">
        <span class="district-tag" v-if="districtName">{{ districtName }}</span>
        <span class="district-tag" v-if="roleText">({{ roleText }})</span>
        <el-dropdown trigger="click" @command="handleCommand">
          <el-avatar icon="el-icon-user-solid" class="headerLogo"></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-aside>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      districtName: "",
      roleText: ""
    };
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      const userInfoStr = localStorage.getItem("adminUserInfo");
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          this.districtName = userInfo.districtName || "";
          const roleMap = {
            SUPER_ADMIN: "超级管理员",
            ADMIN: "管理员",
            STAFF: "工作人员"
          };
          this.roleText = roleMap[userInfo.role] || userInfo.role;
        } catch (e) {
          console.error(e);
        }
      }
    },
    goToScreen() {
      const url = process.env.NODE_ENV === "production"
        ? "https://screen.mtr.xingshantech.cn/#/index"
        : "http://localhost:8090/#/index";
      window.open(url, "_blank");
    },
    handleCommand(command) {
      if (command === "logout") {
        this.$apis.post("/admin/backendUser/logout", {}).then(() => {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("adminUserInfo");
          this.$store.commit("setToken", "");
          this.$store.commit("setAdminUserInfo", "");
          this.$store.commit("setDistrictInfo", {});
          this.$message.success("已退出登录");
          this.$router.push("/login");
        }).catch(() => {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("adminUserInfo");
          this.$router.push("/login");
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/nav-top.vue